import { G } from '@mobily/ts-belt';
import { ColorSwatches, StickerLabelVariant } from '@stitch-fix/mode-react';
import ProductCard from '@stitch-fix/mode-react/ProductCard';
import { BoughtItemsBoughtItemFragment, BoughtItemsShopProductVariantFragment } from '../../utils/hooks/getBoughtItems';
import { BoughtItemsOverflowMenu } from './BoughtItemsOverflowMenu';
import { BoughtItemsActionFooter } from './BoughtItemsActionFooter';
interface BoughtItemsProductCardProps {
  boughtItem: BoughtItemsBoughtItemFragment | null | undefined;
}

/**
 * Formats the Product Card's PDP URL.
 * Sets the `source` and `query_id` query params for tracking events in the PDP.
 */
const getPDPUrl = (variantUrl: string) => {
  const pdpQueryParams = 'source=bought_items';
  return `${variantUrl}&${pdpQueryParams}`;
};
type ProductCardStickerLabelReturnType = {
  text: string;
  variant?: StickerLabelVariant;
};

/**
 * Build sticker label on product card based on top item or return status
 */

const buildStickerLabel = (isGotoItem: BoughtItemsShopProductVariantFragment['isGoToItem'], returnInProgress: BoughtItemsBoughtItemFragment['returnInProgress']): ProductCardStickerLabelReturnType | undefined => {
  if (returnInProgress) {
    return {
      text: 'Return in progress',
      variant: 'navy'
    };
  }
  if (isGotoItem) {
    return {
      text: 'Top Item',
      variant: 'mint'
    };
  }
  return undefined;
};
const BoughtItemsProductCard = ({
  boughtItem
}: BoughtItemsProductCardProps) => {
  if (!G.isObject(boughtItem) || !G.isObject(boughtItem?.shopProduct)) return null;
  const color = boughtItem.variant.color;
  return <ProductCard sku={boughtItem.sku} heroAction={<BoughtItemsOverflowMenu boughtItem={boughtItem} />} actionFooter={<BoughtItemsActionFooter mayHaveOutfits={boughtItem.variant.mayHaveOutfits} returnInProgress={boughtItem.returnInProgress} skuId={boughtItem.sku} orderId={boughtItem.orderId} />} name={boughtItem.shopProduct.name} brand={boughtItem.shopProduct.brand.name} heroStageAspectRatio="1:1" heroMediaUnavailableText="IMAGE UNAVAILABLE" href={getPDPUrl(boughtItem.variant.url)} colorTable={{
    type: 'static',
    element: <ColorSwatches colors={[
    // We only want to display the color of the purchased item
    {
      label: color.name,
      uniqueColorId: color.uniqueColorId,
      hex: color.swatch.hex
    }]} selectedColor={color.name} limit={{
      sm: 1,
      md: 1
    }} />
  }} heroMedia={boughtItem?.variant.image ? {
    alt: boughtItem?.variant.image.altText,
    baseUrl: boughtItem?.variant.image.baseUrl || '',
    mediaPath: boughtItem?.variant.image.mediaPath || '',
    sizes: {
      sm: 320
    }
  } : undefined} stickerLabel={buildStickerLabel(boughtItem?.variant.isGoToItem, boughtItem?.returnInProgress)} />;
};
export default BoughtItemsProductCard;